"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const enhancers_1 = require("./enhancers");
const expand_aliases_1 = __importDefault(require("./expand-aliases"));
const cache = __importStar(require("./cache"));
const styles = __importStar(require("./styles"));
const SELECTORS_PROP = 'selectors';
function enhanceProps(props, selectorHead = '', parentProperty = '') {
    const propsMap = expand_aliases_1.default(props);
    const preservedProps = {};
    let className = props.className || '';
    for (const [property, value] of propsMap) {
        const isSelectorOrChildProp = property === SELECTORS_PROP || parentProperty === SELECTORS_PROP;
        if (isObject(value) && isSelectorOrChildProp) {
            const prop = property === 'selectors' ? '' : property;
            const parsed = enhanceProps(value, noAnd(selectorHead + prop), property);
            className = `${className} ${parsed.className}`;
            continue;
        }
        const enhancer = enhancers_1.propEnhancers[property];
        if (!enhancer) {
            preservedProps[property] = value;
            continue;
        }
        if (value === null || value === undefined || value === false) {
            continue;
        }
        const cachedClassName = cache.get(property, value, selectorHead);
        if (cachedClassName) {
            className = `${className} ${cachedClassName}`;
            continue;
        }
        const newCss = enhancer(value, selectorHead);
        if (newCss) {
            styles.add(newCss.styles);
            cache.set(property, value, newCss.className, selectorHead);
            className = `${className} ${newCss.className}`;
        }
    }
    className = className.trim();
    return { className, enhancedProps: preservedProps };
}
exports.default = enhanceProps;
const isObject = (value) => value != null && typeof value === 'object';
const noAnd = (value) => value.replace(/&/g, '');
